import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({ apidata, columns, searchBy }) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [clientFilter, setClientFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    let filtered = apidata;

    if (dataFilter) {
      filtered = filtered.filter((item) => {
        if (searchBy === "name") {
          return (
            item.id_adhocUser &&
            item.id_adhocUser.name &&
            item.id_adhocUser.name
              .toLowerCase()
              .startsWith(dataFilter.toLowerCase())
          );
        }
        return false;
      });
    }
    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        const itemDate = new Date(item.date);
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        return (!from || itemDate >= from) && (!to || itemDate <= to);
      });
    }

    if (clientFilter) {
      filtered = filtered.filter((item) =>
        item.id_client?.name?.toLowerCase().includes(clientFilter.toLowerCase())
      );
    }

    setFilteredData(filtered);
  }, [dataFilter, apidata, clientFilter, searchBy, fromDate, toDate]);

  const applyFilter = () => {
    setShowFilterModal(false);
  };

  const removeFilter = () => {
    setClientFilter("");
    setFromDate("");
    setToDate("");
    setShowFilterModal(false);
  };

  // ✅ Calculate total payment based on filteredData
  const totalPayment = filteredData.reduce(
    (sum, item) => sum + (item.payment || 0),
    0
  );

  return (
    <div className="table-responsive">
      <div className="col-12 mb-3">
        <div className="d-flex align-items-center gap-3 flex-wrap">
          {/* Search Box */}
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            style={{ maxWidth: "250px" }}
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />

          {/* Filter Button */}
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>

          {/* Total Payment Box */}
          <div className="bg-light border rounded px-3 py-2 text-danger">
            <strong>Total Payment : </strong>{" "}
            {totalPayment.toLocaleString("en-IN")} /-
          </div>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <div className="row justify-content-start">
          <div className="col-12">
            <p>No results found.</p>
          </div>
        </div>
      )}

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        apidata={apidata}
        applyFilter={applyFilter}
        removeFilters={removeFilter}
        applyFilters={() => setShowFilterModal(false)}
        clientFilter={clientFilter}
        setClientFilter={setClientFilter}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
      />
    </div>
  );
}
